import React, { useEffect, useMemo, useState } from 'react'
import NonlalinService from '../../../services/nonlalin/NonlalinService'
import { Offcanvas } from 'react-bootstrap'
import { formatDateTimeLocalDate } from '../../../utilities/Utils'
import NonlalinStatus from '../../../utilities/nonlalin/NonlalinStatus'

const ModalLog = ({ showLog, handleCloseLog, datappm }) => {
    let nonLalinService = useMemo(() => new NonlalinService(), [])
    const [listStatus, setListStatus] = useState(null)

    useEffect(() => {
        // console.log(datappm)
        if (!datappm) return
        const fetchAllData = async () => {
            try {
                const response = await nonLalinService.listNonlalinStatusAll(datappm.nomorAju)
                setListStatus(response.data.data)
            } catch (error) {
                setListStatus(null)
            }
        }
        fetchAllData()
    }, [nonLalinService, datappm])

    return (
        <>
            <Offcanvas
                show={showLog}
                onHide={handleCloseLog}
                placement='end'
                scroll={true}
            >
                <Offcanvas.Header closeButton>
                    <div className="d-flex align-items-center">
                        <h5>
                            Log Status Permohonan
                        </h5>
                    </div>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="iq-timeline0 m-0 d-flex align-items-center justify-content-between position-relative">
                        <ul className="list-inline p-0 m-0 w-100">
                            {
                                listStatus && listStatus.map((sts, index) => {
                                    return (
                                        <li key={index}>
                                            <div className="timeline-dots timeline-dot1 border-danger text-primary"></div>
                                            <h6 className="float-left mb-1"><NonlalinStatus kodeStatus={sts.kodeStatus} /></h6>
                                            <small>Waktu : {formatDateTimeLocalDate(sts.waktuStatus)}</small>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default ModalLog